import { OptionCard, StepBody, StepHeader, StepNav } from "./AiboxWizardParts";

const AiboxStepOutput = ({ outputs, pinSelected, setPinSelected, onNext, onBack }) => (
    <>
        <StepHeader
            title="Which output would you like to link the Ganz AiBox to?"
            subtitle="Make sure the AiBox and the selected output are in the same state. If they differ, the first command only syncs them and will NOT change the AiBox."
        />
        <StepBody>
            {outputs.length === 0 && (
                <p style={{ color: "var(--text-label)", fontSize: "14px", textAlign: "center", marginTop: "2rem" }}>
                    No outputs are available to link.
                </p>
            )}
            {outputs.map(output => (
                <OptionCard
                    key={output.Pin}
                    radio
                    title={output.pinName}
                    selected={pinSelected === output.Pin}
                    onClick={() => setPinSelected(output.Pin)}
                />
            ))}
        </StepBody>
        <StepNav onBack={onBack} onNext={onNext} nextDisabled={pinSelected == null} />
    </>
);

export default AiboxStepOutput;
